'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDocument$002dKind$0024 from "./presto.types$-Document-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$58() {
  this.aGV = null;
  this.aGT = null;
  this.aGU = false;
  this.aGR = null;
  this.aGS = false;
  this.aGW = false;
  this.aGX = false;
  this.aGV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$58 as $c_Lpresto_CredentialsView$$anon$58 };
$p = $c_Lpresto_CredentialsView$$anon$58.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$58;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$58() {
}
export { $h_Lpresto_CredentialsView$$anon$58 as $h_Lpresto_CredentialsView$$anon$58 };
$h_Lpresto_CredentialsView$$anon$58.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.aGV;
});
$p.t = (function() {
  if ((!this.aGU)) {
    this.aGT = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aGU = true;
  }
  return this.aGT;
});
$p.ad = (function() {
  if ((!this.aGS)) {
    this.aGR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dDocument$002dKind$0024.$m_Lpresto_types$DocumentKind$().adk()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aGS = true;
  }
  return this.aGR;
});
$p.v = (function() {
  if ((!this.aGX)) {
    this.aGW = false;
    this.aGX = true;
  }
  return this.aGW;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$58 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$58, "presto.CredentialsView$$anon$58", ({
  Gn: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$58 as $d_Lpresto_CredentialsView$$anon$58 };
//# sourceMappingURL=presto.-Credentials-View$$anon$58.js.map
